import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';


export default {
  name: 'CmrContrPnlReadings', 
  components: {
    DataGridComp: require('@/customcontrols/datagrid.vue').default,
    DataGridOptionsComp: require('@/customcontrols/dataGridOptions/dataGridOptions.vue').default,
    BottomNavButtons: require('@/employee/captureMeterReadings/cmrControlPanel/cmrControlPanelBottomNavButtons.vue').default,
    SearchBar: require('@/components/searchBarWithSearchOptions/searchBarWithSearchOptions.vue').default
  },
  props: ['dataObj'],
  watch: {
    "dataGridDataObj.gridOptions.pagination": function (val) {
      if (val) {
        this.loader = true;
      }

      this.getReadings(false);        
    },
  },
  data: function () {
    return {
      searchTypeList: [
        {
          name: this.$t('captureMR.StatementNo'), id: 1, field: 'StatementNo', boolean: true,
          choices: [
            { name: 'Has Statement', id: 1, value: true },
            { name: 'Does Not Have Statement', id: 2, value: false}
          ]
        },
        { name: this.$t('captureMR.tenantName'), id: 2, field: 'TenantName' },
        { name: this.$t('captureMR.propertyAddress'), id: 3, field: 'Address' },
        { name: this.$t('captureMR.propertyRef'), id: 4, field: 'PropRef' },
      ],
      loader: false,
      dataSource: [],
      dataSourcePaginated: [],
      gridCols: [],
      keyColumn: 'name',
      pageOptions: { pageSize: 10, total: 0, pageNumber: 1 },
      selectedkeys: [],
      totalCount: 0,
      gridChoice: {},
      dataGridDataObj: {
        gridOptions: {
          autoExpand: true,
          pagination: true,
          groupPanel: true,
          columnReordering: false,
          autoClose: false,
        },
        gridOptionsChanged: this.gridOptionsChanged,
        refreshRecords: this.getBooksWalks
      },
      hasNextStep: false,
      showSearch: false,
      readingsHistory: [],
    }
  },
  created() {
    if (this.$store.state.userProfile.portalCaptureMeterReadingsAdmin != true)
      this.$router.push('/employeeHome');

    this.$root.$on('books_walks_selected', (readings) => {
      this.getReadings(true);
      this.showSearch = true;
    });
    this.fillGridCols();
  },
  methods: {
    getReadings(loader = true, searchParam = null) {
      let parameter = {
        BookId: this.dataObj.booksWalks.bookId,
        WalkId: this.dataObj.booksWalks.walkId,
        Status1: 1,
        Status2: 2,
        Status3: 3,
        ListOptions: { pageSize: 10000, pageNumber: 1 },
      };

      if (searchParam != null) {
        parameter = { ...searchParam, ...parameter };
      }

      if (loader)
        this.loader = true;    

      axios.post('/CaptureMeterReading/GetReadings', parameter)
        .then(async response => {
          if (response.data.data.status == 0 && response.data.items.length > 0) {
            await this.getReadingsHistory(response.data.items[0].bookId, response.data.items[0].walkId);
            for (var i = 0; i < response.data.items.length; ++i) {
              response.data.items[i].numbering = i;
              this.prepareReadingForEditing(response.data.items[i]);
            }

            this.dataSource = response.data.items;
            if (this.dataGridDataObj.gridOptions.pagination == true)
              this.pageChange({ pageSize: this.pageOptions.pageSize, pageNumber: this.pageOptions.pageNumber });
            else {
              this.dataSourcePaginated = this.dataSource;
            }
           // this.dataSourcePaginated = this.dataSource;
            this.totalCount = response.data.items.length;
          }
        })
        .catch(e => {
          console.log("err", e)
          //this.$router.push('/login');
        })
        .finally(() => {
          this.loader = false;
        });
    },
    async getReadingsHistory(BookId, WalkId) {
      return await axios.post('/CaptureMeterReading/GetReadingsHistory', { BookId, WalkId })
        .then(response => {
          if (response.status == 200) {
            this.readingsHistory = response.data.items;
            return true;
          }
          return false;
        })
        .catch(e => {
          return false;
        });
    },
    prepareReadingForEditing(record) {
      record.fullId = record.bookId + '-' + record.walkId + '-' + record.sequence;
      record.prRead1 = (record.prRead1 === null) ? 0 : record.prRead1;
      record.statusText = record.status === 1 ? 'Unread' : record.status === 2 ? 'Read' : record.status === 3 ? 'Completed' : 'Unknown';
      record.crDate = new Date(record.crDate);
      record.prDate1 = new Date(record.prDate1);
      record['changeOfAverageCons'] = ((record.consumption - record.prCons1) / record.consumption) * 100;
      record['name'] = record.numbering;
      record['accessDisplay'] = this.dataObj.descrepancyNoAccess.filter(a => a.id == record.accessCodeId)[0].name;
      record['noteDisplay'] = this.dataObj.descrepancyMrNote.filter(a => a.id == record.mrMsgCodeId)[0].name;
      record.checkReading = record.checkReading == true;

      let cons = 0;
      if (record.crReading == null || record.crReading == "" || record.prRead1 == 0) {
        record.consumption = "";
        record.curAvrCns = 0;
      }
      else {
        record.consumption = record.crReading - record.prRead1;
        if (record.clockOver) {
          let clockValue = "";
          for (let i = 0; i < record.noDials; i++)
            clockValue = clockValue + "9";

          record.consumption = record.consumption + parseInt(clockValue);
        }

        var dCurrent = moment(record.crDate);
        var dPrevious = moment(record.prDate1);
        var iDiffDays = dCurrent.diff(dPrevious, 'days') + 1;

        //console.log("idif", iDiffDays)
        record.curAvrCns = iDiffDays > 0 ? record.consumption / iDiffDays : 0;
        record["curAvrCnsDisplay"] = this.roundNumber(record.curAvrCns, 4);
        record["prAvrCnsDisplay"] = this.roundNumber(record.prAvrCns, 4);
        record["originalRejectedState"] = record.rejected;
      }
      record['gpsStatus'] = record.connectionCoordY && record.connectionCoordX ? true : false;
    },
    roundNumber(value, decimals) {
      return Number( Math.round(Number(value + "e" + decimals)) + "e-" + decimals );
    },
    pageChange(pInfo) {
      let start = pInfo.pageNumber * pInfo.pageSize - pInfo.pageSize;
      let end = start + pInfo.pageSize;

      this.dataSourcePaginated = this.dataSource.slice(start, end);
    },
    pagination() {

    },
    calculateCellClass(value) {
      return value.data.problemStatusVal === 0 ? 'recordTypeOrange' :
        value.data.problemStatusVal === 1 ? 'recordTypeGray' :
          value.data.problemStatusVal === 2 ? 'recordTypeBlack' :
            value.data.problemStatusVal === 3 ? 'recordTypeTeal' :
              value.data.problemStatusVal === 4 ? 'recordTypeBlue' :
                value.data.problemStatusVal === 5 ? 'recordTypeGreen' : 'recordTypePurple';

    },
    selectionChanged(info) {

    },
    onRowDblClick(info) {
      //console.log("infoi", info.data.sequence)
      this.gridChoice = this.dataSource.filter(b => b.sequence == info.data.sequence && b.serialNo == info.data.serialNo)[0];
      this.loader = true;
      this.dataObj.selected(this.prepareReading(this.gridChoice), this.dataSource);
      this.loader = false;
      this.hasNextStep = true;
    },
    onCellClick(pInfo) {
      //console.log("onCellClick", pInfo)

      if (pInfo.columnIndex == 4) {
        let read = this.dataSource.filter(d => d.sequence == pInfo.data.sequence)[0];

        if (!read)
          return;

        read.checkReading = !read.checkReading;

        axios.post('/CaptureMeterReading/UpdateCheckReadingFlag', {
          BookId: read.bookId,
          WalkId: read.walkId,
          Sequence: read.sequence,
          CheckReading: read.checkReading == true,
        })
          .then(res => {
            if (res.status != 200 || res.data.data.status != 0) {
              read.checkReading = false;
            }
          })
          .catch(err => { read.checkReading = false; })
      }
    },

    prepareReading(selectedReading) {
      if (!selectedReading)
        return {};

      //this.iValueEditIndex = selectedReading.numbering;

      let editingHistory = [...this.readingsHistory.filter((a) => a.sequence == selectedReading.sequence)];
      
      for (let i = 0; i < 4; i++) {
        editingHistory[i]['id'] = i;
        editingHistory[i]['type'] = selectedReading.previousReadingType[i];
      }
        
      /*selectedReading.crDate = new Date();*/

      //selectedReading["access"] = this.accessCodeIdToDescription(selectedReading.accessCodeId);
      //selectedReading["mrMsg"] = this.msgCodeIdToDescription(selectedReading.mrMsgCodeId);

      //this.setConsumption(selectedReading);
      //this.submetersHaveValue();
      //this.GetConnectionSpHeader();
      //this.getPhotos();
      //this.picUploaded = false;
      return { selectedReading, editingHistory };
    },
    fillGridCols() {
      this.gridCols = [
        { dataField: 'sequence', name: 'sequence', caption: this.$t('captureMR.ColumnSequence') },
        { dataField: 'propRef', name: 'propRef', caption: this.$t('captureMR.ColumnConnection') },
        { dataField: 'account', name: 'account', caption: this.$t('captureMR.ColumnCustomerNo') },
        { dataField: 'readingDiscrepancy', name: 'readingDiscrepancy', caption: this.$t('captureMR.ColumnDiscrepancy') },
        { dataField: 'checkReading', name: 'checkReading', caption: this.$t('captureMR.CheckReading') },
        //{ dataField: 'action??', name: 'action??', caption: this.$t('captureMR.ColumnAction') },
        //{ dataField: 'request??', name: 'request??', caption: this.$t('captureMR.ColumnRequest') },
        { dataField: 'meterRef', name: 'meterRef', caption: this.$t('captureMR.ColumnMeterNo') },
        { dataField: 'tenantName', name: 'tenantName', caption: this.$t('captureMR.ColumnOccupier') },
        { dataField: 'propertyAddress', name: 'propertyAddress', caption: this.$t('captureMR.ColumnPropertyAddress') },
        //{ dataField: 'changeOfAverageCons', name: 'changeOfAverageCons', caption: this.$t('captureMR.ColumnPerCentChange') }, //TBI from back-end
        { dataField: 'prDate1', name: 'prDate1', caption: this.$t('captureMR.ColumnPrevDate') },
        { dataField: 'prRead1', name: 'prRead1', caption: this.$t('captureMR.ColumnPrevRdg') },
        { dataField: 'prCons1', name: 'prCons1', caption: this.$t('captureMR.ColumnPrevAvgCons') },
        { dataField: 'crDate', name: 'crDate', caption: this.$t('captureMR.ColumnCurDate') },
        { dataField: 'crReading', name: 'crReading', caption: this.$t('captureMR.ColumnCurRdg') },
        { dataField: 'clockOver', name: 'clockOver', caption: this.$t('captureMR.ColumnClockOver') },
        { dataField: 'consumption', name: 'consumption', caption: this.$t('captureMR.ColumnCurCons') },
        { dataField: 'prAvrCnsDisplay', name: 'prAvrCns', caption: this.$t('captureMR.prevAvgCons') },
        { dataField: 'curAvrCnsDisplay', name: 'curAvrCnsDisplay', caption: this.$t('captureMR.avgCons') },
        { dataField: 'accessDisplay', name: 'tenantName', caption: this.$t('captureMR.Access') },
        { dataField: 'noteDisplay', name: 'propertyAddress', caption: this.$t('captureMR.Note') },
        { dataField: 'comment', name: 'comment', caption: this.$t('captureMR.Comment') },
        //{ dataField: 'meterRef', name: 'meterRef', caption: this.$t('captureMR.MeterReader') },
        { dataField: 'meterTagNo', name: 'meterTagNo', caption: this.$t('captureMR.MeterTagNo') },
        { dataField: 'gpsStatus', name: 'gpsStatus', caption: this.$t('captureMR.GPS') },
       ]
    },
    gridOptionsChanged(item) {
      //console.log("djdjdj", item)
    },
    searchReadings(item) {
      if (item.clearSearch != true) {
        let searchParam = { [item.field]: item.query };
        this.getReadings(false, searchParam);
      }
      else
        this.getReadings(false);      
    }
  },
}
